/**
 * Browser tab / analytics titles: "{page} :: Navitas Safety".
 * Entity edit screens add " :: Users|Organizations|Resellers" via setEntityEditDocumentTitle only.
 * @param {object} to Vue Router route object
 * @returns {string}
 */
export const TITLE_SUFFIX = ' :: Navitas Safety';

export function getRoutePageTitle(to) {
  const record = [...to.matched]
    .reverse()
    .find((r) => r.meta && r.meta.title);
  const page = (record && record.meta.title) || 'Navitas Safety';
  return page + TITLE_SUFFIX;
}

/**
 * Tab title for entity edit screens: "Name (id)" + suffix.
 * @param {string} displayName
 * @param {string|number} id
 * @param {string} entityFallback e.g. "User" when name not loaded yet
 * @returns {string} without TITLE_SUFFIX
 */
export function formatEditEntityTitle(displayName, id, entityFallback) {
  const fallback = entityFallback || 'Record';
  const label = String(displayName || '').trim();
  const idStr =
    id !== undefined && id !== null && String(id).trim() !== ''
      ? String(id).trim()
      : '';
  if (label && idStr) {
    return `${label} (${idStr})`;
  }
  if (idStr) {
    return `${fallback} (${idStr})`;
  }
  if (label) {
    return label;
  }
  return fallback;
}

const ENTITY_SECTION_SUFFIX = {
  User: ' :: Users',
  Reseller: ' :: Resellers',
  Organization: ' :: Organizations',
};

/**
 * Sets document.title; optionally sends a page_view so GA matches the tab after async load.
 * @param {object} vm Vue component instance (this)
 * @param {string} displayName
 * @param {string|number} id
 * @param {string} entityFallback
 * @param {{ sendPageView?: boolean }} options defaults sendPageView true
 */
export function setEntityEditDocumentTitle(
  vm,
  displayName,
  id,
  entityFallback,
  options = {}
) {
  const sendPageView = options.sendPageView !== false;
  const base = formatEditEntityTitle(displayName, id, entityFallback);
  const sectionSuffix =
    ENTITY_SECTION_SUFFIX[entityFallback] || '';
  const full = base + sectionSuffix + TITLE_SUFFIX;
  document.title = full;
  if (
    sendPageView &&
    vm.$gtag &&
    typeof vm.$gtag.pageview === 'function'
  ) {
    vm.$gtag.pageview({
      page_path: vm.$route.fullPath,
      page_title: full,
    });
  }
}
